import { useAuthStore } from '@/stores/auth'
import { showOverlay, hideOverlay } from '@/composables/useOverlay'
import { pushToast } from '@/composables/useToast'

export function StartLoading(text: string) {
  if (text !== '') {
    showOverlay(text)
  }
}

export function StopLoading() {
  hideOverlay()
}

export function ShowError(text: string) {
  if (text !== '') {
    pushToast({ type: 'error', title: text })
  }
}

export function ShowLogOutError(router: { push: (location: { name: string }) => void }) {
  useAuthStore().logout()
  router.push({ name: 'sign-in' })
  pushToast({
    type: 'info',
    title: 'Session Expired',
    message: 'Please login again.',
  })
}
